var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7055 9.39163H10.0209L9.78452 9.15395C10.7121 8.05764 11.1798 6.64415 11.0896 5.20992C10.9994 3.7757 10.3582 2.43218 9.30063 1.46116C8.24301 0.490137 6.85109 -0.0329503 5.41682 0.00160966C3.98255 0.0361697 2.61736 0.625688 1.60758 1.64653C0.597793 2.66737 0.0218724 4.04021 0.000610264 5.47712C-0.0206518 6.91403 0.514395 8.30337 1.49353 9.35373C2.47267 10.4041 3.81982 11.0339 5.25243 11.111C6.68505 11.1881 8.09183 10.7066 9.17772 9.7674L9.41406 10.006V10.688L13.7179 15L15 13.712L10.7055 9.39163ZM5.54067 9.39163C4.77256 9.39331 4.02122 9.16669 3.38174 8.74045C2.74227 8.31422 2.24341 7.70754 1.94831 6.9972C1.65321 6.28686 1.57513 5.50479 1.72396 4.74999C1.87278 3.99518 2.24182 3.30156 2.78437 2.75693C3.32692 2.21229 4.01858 1.84114 4.77181 1.69042C5.52504 1.5397 6.30598 1.61621 7.01578 1.91025C7.72559 2.2043 8.33235 2.70266 8.75926 3.34227C9.18618 3.98187 9.41406 4.73397 9.41406 5.50336C9.41468 6.01343 9.31497 6.51863 9.12064 6.99011C8.9263 7.46158 8.64115 7.8901 8.28146 8.25117C7.92177 8.61224 7.49459 8.8988 7.02432 9.09449C6.55405 9.29017 6.0499 9.39114 5.54067 9.39163Z",
    fill: "#C4C4C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.9b255a33.svg";
export { ForwardRef as ReactComponent };